
import React, { useEffect, useState } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import PathContext from "./context/path";
import StateContext from "./context/state";
import Compare from './pages/Compare';
import Main from './pages/Main';
import Services from './pages/Services';
import Wrap from './pages/Wrap';
const App = () => {

  const [stage, setStage] = useState(0);
  const [allStages, setAllStages] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [touchMove, setTouchMove] = useState(false);
  const [counting, setCounting] = useState(false);
  const [transition, setTransition] = useState(false);
  const [reverse, setReverse] = useState(false);
  const [isMobile, setMobile] = useState(false);
  const [popup, setPopup] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const updateStage = (number) => {

    return setStage(number);
  }
  const updateAllStages = (number) => {
    return setAllStages(number);
  }
  const updateTransition = (bool) => {
    return setTransition(bool);
  }
  const updatePlayPopup = (bool) => {
    return setPopup(bool);
  }
  const updateReverse = (bool) => {
    return setReverse(bool);
  }
  const updateMenuOpen = (bool) => {
    return setMenuOpen(bool);
  }

  // useEffect(()=>{
  //   // console.clear();

  //   console.log(`=============`);
  //   // console.log(`stage-${stage} (slide #${stage+1})`);
  //   console.log(`stage-${stage}`);
  // },[stage]);
  
  useEffect(() => {
    const handleMobile = () => {
      if (window.outerWidth < 768 && !isMobile) {
        setMobile(true);
      }
      if (window.outerWidth > 767 && isMobile) {
        setMobile(false);
      }
    }
    handleMobile();
    window.addEventListener('resize', handleMobile);
    return () => {
      window.removeEventListener('resize', handleMobile);
    }
  }, [isMobile]);
  useEffect(() => {
    if (!touchMove && !counting) {
      setCounting(true);
      const xDiff = touchStart - touchEnd;
      if (xDiff > 10 && stage < allStages - 1) {
        setStage(prev => prev + 1)
      }
      if (xDiff < -10 && stage > 0) {
        setStage(prev => prev - 1)
      }
    }
  }, [allStages, counting, stage, touchEnd, touchMove, touchStart]);

  // useEffect(()=>{

  //   console.log(`transition: ${transition}`);
  //   console.log(`=============`);
  // },[transition]);
  // useEffect(()=>{

  //   console.log(`reverse: ${reverse}`);
  //   console.log(`=============`);
  // },[reverse]);
  useEffect(() => {
    if (popup || menuOpen) {
      setTransition(true);
    } else {
      setTransition(false);
    }
  }, [menuOpen, popup]);
  useEffect(() => {
    setCounting(false);
    setTouchMove(false);
  }, [touchEnd]);

  useEffect(() => {
    function handleTouchStart(e) {
      const withinBoundaries = e.composedPath().includes(document.querySelector('[data-pagination]'));
      if (withinBoundaries || transition) {
        return;
      }
      document.addEventListener('touchend', handleTouchEnd, false);
      document.addEventListener('mouseup', handleTouchEnd, false);
      setTouchMove(true);
      if (isMobile) {
        setTouchStart(e.clientY || e.targetTouches[0].clientY);
      } else {
        setTouchStart(e.clientX || e.targetTouches[0].clientX);
      }
    }
    function handleTouchEnd(e) {
      document.removeEventListener('touchend', handleTouchEnd, false);
      document.removeEventListener('mouseup', handleTouchEnd, false);
      if (isMobile) {
        setTouchEnd(e.clientY || e.changedTouches[0].clientY);
      } else {
        setTouchEnd(e.clientX || e.changedTouches[0].clientX);
      }
    }
    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('mousedown', handleTouchStart, false);
    return () => {
      document.removeEventListener('touchstart', handleTouchStart, false);
      document.removeEventListener('mousedown', handleTouchStart, false);
      document.removeEventListener('touchend', handleTouchEnd, false);
      document.removeEventListener('mouseup', handleTouchEnd, false);
    }
  }, [isMobile, transition]);

  // useEffect(()=>{
  //   if(transition){
  //     setTimeout(() => {
  //       setTransition(false);
  //     }, 800);
  //   }
  // },[transition]);

  // const basename = '/demo/utlc';
  // const basenameContext = basename;
  const basename = '';
  const basenameContext = '.';
  window.mediaPath = basename;
  return (

    <StateContext.Provider value={{ stage: stage, allStages: allStages, updateAllStages: updateAllStages, updateStage: updateStage, transition: transition, updateTransition: updateTransition, updatePlayPopup: updatePlayPopup, popup: popup, updateReverse: updateReverse, reverse: reverse, updateMenuOpen: updateMenuOpen, menuOpen: menuOpen, isMobile: isMobile }}>
      <PathContext.Provider value={basenameContext}>
        <Router basename={basename}>
          <Routes>

            <Route path="/" element={<Wrap />}>
              <Route index element={<Main />} />
              <Route path={'compare'} element={<Compare />} />
              <Route path={'services'} element={<Services />} />

            </Route>
          </Routes>
        </Router>
      </PathContext.Provider>
    </StateContext.Provider>
  );

}


export default App;
